import { ICalendarEvent } from 'APP/model/calendar/calendar.types';

export function isRecurringEvent(event: ICalendarEvent): boolean {
  return !!event.recurrenceType && event.recurrenceType !== 'NONE';
}
